import React, { useState, useRef, useEffect } from "react";
import { gsap } from "gsap";

// Images
import jobBg from "../../images/bg/job-bg.png";
import diamondIcon from "../../images/icon/diamond-icon02.gif";

import locIcon from "../../images/icon/location-icon02.svg";
import clockIcon from "../../images/icon/clock-icon.svg";
import { Link } from "react-router-dom";

// JOB DATA
const jobs: any[] = [
  {
    id: 1,
    title: "Full Stack Developer",
    category: ["cat1"],
    location: "Remote, India",
    type: "Full time",
    slug: "full-stack-developer",
    isActive: false,
  },
  {
    id: 2,
    title: "UI / UX Designer",
    category: ["cat1"],
    location: "Remote, India",
    type: "Full time",
    slug: "ui-ux-designer",
    isActive: false,
  },
  {
    id: 3,
    title: "Front-end Developer",
    category: ["cat1"],
    location: "Remote, India",
    type: "Full time",
    slug: "frontend-developer",
    isActive: false,
  },
  {
    id: 4,
    title: "MERN/MEAN Stack Developer",
    category: ["cat1"],
    location: "Remote, India",
    type: "Full time",
    slug: "mern-mean-stack-developer",
    isActive: false,
  },
  {
    id: 5,
    title: "Business Analyst",
    category: ["cat2"],
    location: "Remote, India",
    type: "Full time",
    slug: "business-analyst",
    isActive: false,
  },
  {
    id: 6,
    title: "Digital Marketing",
    category: ["cat3"],
    location: "Remote, India",
    type: "Full time",
    slug: "digital-marketing",
    isActive: false,
  },
];

// Helper to get only active jobs
const getActiveJobs = () => jobs.filter(job => job.isActive !== false);

const filters = [
  { label: "View all", value: "*" },
  { label: "Technical", value: "cat1" },
  { label: "Business", value: "cat2" },
  { label: "Marketing", value: "cat3" },
];

const JobSection: React.FC = () => {
  const [activeFilter, setActiveFilter] = useState("*");
  const itemsRef = useRef<HTMLDivElement[]>([]);
  const activeJobsList = getActiveJobs();

  // Filtering + animation
  useEffect(() => {
    if (activeJobsList.length === 0) return;
    itemsRef.current.forEach((el) => {
      if (!el) return;

      const categories = el.dataset.category?.split(" ") ?? [];
      const show = activeFilter === "*" || categories.includes(activeFilter);

      // Animate show/hide with GSAP
      if (show) {
        el.style.display = "block";
        gsap.to(el, {
          opacity: 1,
          scale: 1,
          duration: 0.4,
          pointerEvents: "auto",
        });
      } else {
        gsap.to(el, {
          opacity: 0,
          scale: 0.8,
          duration: 0.4,
          pointerEvents: "none",
          onComplete: () => {
            el.style.display = "none";
          }
        });
      }
    });
  }, [activeFilter, activeJobsList.length]);

  return (
    <section
      className="job_section pt-90 pb-150 bg_img"
      style={{ backgroundImage: `url(${jobBg})` }}
    >
      <div className="container">

        {/* TITLE */}
        <div className="sec-title sec-title-center fea-sec-title text-center mb-40">
          <span className="sub-title">Open Positions</span>
          <h2 className="title">
            Be part of{" "}
            <span>
              <img src={diamondIcon} alt="icon" />
            </span>
            the team
          </h2>
        </div>

        {/* FILTER BUTTONS */}
        {activeJobsList.length > 0 && (
          <div className="text-center">
            <div className="career-menu ul_li">
              {filters.map((btn, i) => (
                <button
                  key={i}
                  className={activeFilter === btn.value ? "active" : ""}
                  onClick={() => setActiveFilter(btn.value)}
                >
                  {btn.label}
                </button>
              ))}
            </div>
          </div>
        )}

        {/* JOB GRID OR NO OPENINGS MESSAGE */}
        {activeJobsList.length > 0 ? (
          <div className="career-nav-wrapper grid mt-40">
            {activeJobsList.map((job, i) => (
              <div
                key={job.id}
                ref={(el) => (itemsRef.current[i] = el!)}
                className="xb-career-item grid-item xb-border"
                data-category={job.category.join(" ")}
                style={{ 
                  opacity: 1, 
                  display: "flex", 
                  justifyContent: "space-between", 
                  alignItems: "center",
                  flexWrap: "wrap",
                  gap: "15px"
                }}
              >
                <div className="xb-item--content">
                  <h2 className="xb-item--title">
                    <Link to={`/career-details?job=${job.slug}`}>{job.title}</Link>
                  </h2>

                  <ul className="xb-item--holder ul_li list-unstyled">
                    <li>
                      <img src={locIcon} alt="location" /> {job.location}
                    </li>
                    <li>
                      <img src={clockIcon} alt="clock" /> {job.type}
                    </li>
                  </ul>
                </div>

                {/* BUTTON - outside content div for flex positioning */}
                <div className="team-btn">
                  <Link className="thm-btn agency-btn" to={`/career-details?job=${job.slug}`}>
                    <span className="text">view job</span>
                    <span className="arrow">
                      <span className="arrow-icon"></span>
                    </span>
                  </Link>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="no-openings-message text-center py-5" style={{
            background: "rgba(255, 255, 255, 0.02)",
            borderRadius: "16px",
            border: "1px dashed rgba(255, 255, 255, 0.12)",
            padding: "50px 30px",
            backdropFilter: "blur(10px)",
            maxWidth: "600px",
            margin: "40px auto 0 auto"
          }}>
            <div style={{
              fontSize: "48px",
              marginBottom: "20px",
              display: "inline-block"
            }}>
              💼
            </div>
            <h3 style={{
              color: "#fff",
              fontSize: "24px",
              fontWeight: 600,
              marginBottom: "12px",
              letterSpacing: "-0.5px"
            }}>
              Currently No Openings
            </h3>
            <p style={{
              color: "rgba(255, 255, 255, 0.6)",
              fontSize: "16px",
              lineHeight: "1.6",
              maxWidth: "450px",
              margin: "0 auto"
            }}>
              We don't have any open positions right now. Please check back later or send us your resume to stay in touch!
            </p>
          </div>
        )}

      </div>
    </section>
  );
};

export default JobSection;
